import { useMemo } from 'react';

const useCostCalculatorMediaGeneration = (model, selectedParams, prompt) => {
  const calculateCost = useMemo(() => {
    const { pricing } = model || {};
    if (!pricing) return 0;

    let cost = pricing.base_cost || 0;

    // Calculate word count from prompt (for audio generators)
    const wordCount = prompt ? prompt.split(' ').length : 0;

    // Apply modifiers using single loop with switch statement (matching backend)
    for (const modifier of pricing.modifiers || []) {
      const paramValue = selectedParams?.[modifier.parameter];
      if (paramValue === undefined || paramValue === null) continue;

      switch (modifier.type) {
        case 'value_factor':
          const matched = modifier.rules?.find((v) => v.value === paramValue);
          if (matched) {
            cost *= matched.factor || 1;
          }
          break;

        case 'multiplier':
          if (typeof paramValue === 'number') {
            cost *= paramValue;
          }
          break;

        default:
          break;
      }
    }

    // Apply word count multiplier for audio (if applicable)
    if (wordCount > 0 && pricing.per_word_cost) {
      const perWordCost = pricing.per_word_cost * wordCount;
      cost += perWordCost;
    }

    // Additional features specific to frontend
    if (selectedParams?.use_thought === true) {
      cost *= 1.2;
    }

    if (selectedParams?.optimize_prompt === true) {
      cost += 10;
    }

    return Math.ceil(cost); // Round up to avoid decimals
  }, [model, selectedParams, prompt]);

  return calculateCost;
};

export default useCostCalculatorMediaGeneration;
